import React from "react"
import PropTypes from 'prop-types'

const Filter = ({
  style     = {},
  fill      = "currentColor",
  width     = "100%",
  className = "filter",
  viewBox   = "0 0 24 24"
}) => (
  <svg
    width     = {width}
    style     = {style}
    viewBox   = {viewBox}
    xmlns     = "http://www.w3.org/2000/svg"
    className = {`svg-icon ${className || ""}`}
  >
    <path d="M6.5 4a3.5 3.5 0 110 7 3.5 3.5 0 010-7m13 2h-7.713c.136.478.213.979.213 1.5s-.077 1.022-.213 1.5H19.5c.825 0 1.5-.675 1.5-1.5S20.325 6 19.5 6M22 16.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0M13.213 18H5.5c-.825 0-1.5-.675-1.5-1.5S4.675 15 5.5 15h7.713A5.464 5.464 0 0013 16.5c0 .521.077 1.022.213 1.5" fill={fill} fillRule="evenodd"/>
  </svg>
)

Filter.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default Filter
